export const enum WidgetType {
    TEXT = "Text",
    IMAGE = "Image",
    VIDEO = "Video",
    AUDIO = "Audio",
    FILE = "File",
    WEB_EMBED = "Web Embed",
    WEB_PAGE = "Web Page",
    EXISTING = "existing",
    YOUTUBE = "YouTube",
    VIMEO = "Vimeo",
    GIPHY = "Giphy",
    GOOGLE_MAPS = "Google Maps",
    HTML = "HTML",
    LIST = "List",
    PAGE = "Page",
    RSS = "RSS",
    CONTACT = "Contact",
    COMBINED_FEED = "Combined Feed",
    DUPLICATE = "Duplicate"
}

export const enum EmbedType {
    YOUTUBE = "YouTube",
    VIMEO = "Vimeo",
    GIPHY = "Giphy",
    GOOGLE_MAPS = "Google Maps",
    HTML = "HTML"
}